import Layout from "./dashboard-layout/layout";

export default function ComingSoonPage() {
  return (
    <Layout>
      <h1>This page coming soon</h1>
    </Layout>
  );
}
